module.exports = __webpack_public_path__ + "static/media/greybay.27ae5877.png";